<template>
    <v-container>
        <v-row>
            <v-col class="d-flex justify-center">
                <h1 class="text-uppercase page-header text-center">{{ project.title }}</h1>
            </v-col>
        </v-row>
        <v-row class="mb-3">
            <v-col class="d-flex justify-center">
                <h3 class="page-sub-header text-center">{{ project.subtitle }}</h3>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="12" lg="6" xl="6">
                <v-img :src="require(`@/assets/img/portfolio/${project.image}`)" />
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="12" lg="6" xl="6" v-html="project.description" />
        </v-row>
        <v-row class="justify-center mb-8" v-if="project.link && project.link != ''">
            <v-col cols="12" lg="6" xl="6" class="d-flex justify-center">
                <v-btn dark :href="project.link" target="_blank" rel="noopener noreferrer">
                    View {{ project.title }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="12" lg="6" xl="6">
                <v-chip-group column class="read-only-chips">
                    <v-chip v-for="tag in project.tags" :key="tag" disabled dark>
                        {{ tag }}
                    </v-chip>
                </v-chip-group>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col lg="3" xl="3">
                <v-btn icon v-if="showPreviousArrow" @click="goToProject(-1)">
                    <font-awesome-icon class="icon-font-size" :icon="['fas', 'chevron-circle-left']" />
                </v-btn>
            </v-col>
            <v-col lg="3" xl="3" class="d-flex" style="justify-content: right">
                <v-btn icon v-if="showNextArrow" @click="goToProject(1)">
                    <font-awesome-icon class="icon-font-size" :icon="['fas', 'chevron-circle-right']" />
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import projects from '@/data/projects';

    export default {
        name: 'PortfolioItem',
        props: {
            id: String,
        },
        watch: {
            id(newVal, oldVal) {
                if (newVal != oldVal)
                    window.scrollTo(0,0);
            }
        },
        computed: {
            currentProjectIdx() {
                return projects.findIndex(p => p.id == this.id);
            },
            showPreviousArrow() {
                return false && this.currentProjectIdx > 0;
            },
            showNextArrow() {   // TODO: justify-content: right does not work on Safari
                return false && this.currentProjectIdx < projects.length - 1;
            },
            project() {
                return projects.filter(p => p.id == this.id)[0];
            }
        },
        methods: {
            goToProject(addIdx) {
                const idx = this.currentProjectIdx + addIdx;
                this.$router.push({ name: 'Project', params: { id: projects[idx].id }})
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global.scss';

</style>